import { render, staticRenderFns } from "./ObligationView.vue?vue&type=template&id=7abf3218&scoped=true&"
import script from "./ObligationView.vue?vue&type=script&lang=js&"
export * from "./ObligationView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7abf3218",
  null
  
)

export default component.exports